import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AbstractService } from '../../abstractions/abstract-typed.service';
import { Globals } from '../../app.globals';

@Injectable()
export class PlantQRCodeService extends AbstractService<any> {
    constructor(public http: HttpClient, public globals: Globals) {
        super(http, globals);
    }

    getApiUrl() {
        return "api/projects/"
    }

    generateQRCode(projectId: number, plantType: string, id: number): Observable<string> {
        return this.http
            .get(
                this.getApiUrl() +
                projectId +
                "/procurement/qrcode/" +
                plantType +
                "/generateqrcode/" +
                id,
                {
                    responseType: 'text'
                }
            )
            .pipe(
                map((res) => res),
                catchError(this.handleError)
            );
    }
}
